// @flow
import * as React from 'react';
import { connect } from "react-redux";
import styled from 'styled-components';
import _ from 'lodash';

import { Redirect } from 'react-router-dom';
import * as selectors from "../../modules/selectors";
import * as actions from '../../modules/actions';
import { below, above } from '../../assets/css/media';
import { SwitchButton } from '../../components';
import ArrowUp from '../../components/Icons/ArrowUp';
import ArrowDown from '../../components/Icons/ArrowDown';
import Table, { TBody, THead, Tr, Th } from '../../components/TableX';
import {
	ButtonAlert,
	ConfirmationModal,
	PageTitle,
} from '../../components';
import TeamUserAvatar from '../../components/Team/TeamUserAvatar';

import DraftLayout from '../../components/Draft/DraftLayout';
import Aside from '../../components/Draft/Aside';
import TdYourTeam from '../../components/Draft/TdYourTeam';
import TdStat from '../../components/Draft/TdStat';
import DraftTitleContainer from '../../components/Draft/DraftTitleContainer';
import DraftOrder from '../../components/Draft/DraftOrder';
import colors from "../../assets/css/colors";

type Props = {
	selected_league_id: number,
	showDraftOrder: typeof actions.leagueDraft.showDraftOrder,
	changeDraftOrder: typeof actions.leagueDraft.changeDraftOrder,
	leaveDraftLeague: typeof actions.leagueDraft.leaveDraftLeague,
	fetchLadder: typeof actions.leagueDraft.ladderDraftLeague,
	removeTeamDraftLeague: typeof actions.leagueDraft.removeTeamDraftLeague,
	fetchLeague: typeof actions.leagueDraft.showDraftLeague,
	ladder_teams_ordered: Array<Object>,
	is_pending_show: boolean,
	user_id: number,
	league: Object,
	teams: Array<Object>,
	draft_order: Array<number>,
	error?: string,
	match: {
		params: {
			league_id: string
		}
	},
	leave_league_success: boolean,
	remove_team_success: boolean,
}

const TeamUserAvatarStyled = styled(TeamUserAvatar)`
	width: 40px;
`;

const TdDraftPosition = styled(TdYourTeam)`
	display: flex;
`;
const TdDraftOrder = styled(TdYourTeam)`
	font-size: 30px;
	padding-top: 10px;
	margin-left: 30px;
`;


const OrderDiv = styled.div`
	float: right;
`;

const DraftOrderRow = styled(Tr)`
	height: 60px;
`;

const DraftOrderTh = styled(Th)`
	font-size: 12px;
	line-height: 10px;
	text-align: center;
`;

const TeamTh = styled(DraftOrderTh)`
	text-align: right;
`;

const DraftOrderThHideSmall = styled(DraftOrderTh)`
	${below.tablet`
		display: none;
	`}
`;

const DraftOrderThHideLarge = styled(DraftOrderTh)`
	${above.tablet`
		display: none;
	`}
`;

const TdStatHideSmall = styled(TdStat)`
	${below.tablet`
		display: none;
	`}
`;

const DraftDiv = styled.div`
	padding-bottom: 50px;
`;

const ArrowDiv = styled.div`
	display: block !important;
`;

// const NoOrderDiv = styled.div`
// 	text-align: center;
// 	font-size: 20px;
// 	font-weight: 600;
// 	padding-top: 30px;
// `;


const TeamName = styled.div`
	font-size: 12px;
	line-height: 1.125;
	font-weight: bold;
	text-align: left;
	color: ${colors.nrlDarkGreen};
	text-overflow: ellipsis;
	overflow: hidden;
	max-width: 60px;

	${above.phone`
		font-size: 14px;
		max-width: 150px;
	`}

	${above.tablet`
		max-width: 100px;
	`}

	${above.desktop`
		max-width: 200px;
	`}
`;

const UserName = styled.div`
	font-size: 12px;
	line-height: 1.28;
	text-align: left;
	color: ${colors.darkGrey};
	text-overflow: ellipsis;
	overflow: hidden;
	max-width: 60px;

	${above.phone`
		max-width: 150px;
	`}

	${above.tablet`
		max-width: 100px;
	`}

	${above.desktop`
		max-width: 200px;
	`}

	${below.phone`
		display: none;
	`}
`;

type State = {
	show_leave_modal: boolean,
	show_remove_modal: boolean,
	left_the_league: boolean,
	remove_the_team: boolean,
	remove_id: number,
};

class LeagueDraftOrderComponent extends React.Component<Props, State> {

	state = {
		show_remove_modal: false,
		show_leave_modal: false,
		left_the_league: false,
		remove_the_team: false,
		remove_id: 0,
	};

	constructor(props, state) {
		super(props, state);

		_.bindAll(this, [
			'leaveThisLeague',
			'removeFromLeague',
			'confirmLeaveleague',
			'confirmRemoveTeamleague',
			'closeLeaveModal',
			'closeRemoveModal',
			'updateArrowsDraftOrder',
			'updateTextDraftOrder',
		]);
	}

	componentDidMount() {
		this.fetchLeague();
		this.fetchLadder();
		const { league_id } = this.props.match.params;
		this.props.showDraftOrder({ league_id });
	}

	confirmLeaveleague() {
		const { leaveDraftLeague, league: { id } } = this.props;
		leaveDraftLeague({ league_id: id });
		this.setState({ left_the_league: true });

	}

	confirmRemoveTeamleague() {
		const { removeTeamDraftLeague, league: { id } } = this.props;
		const team_id = this.state.remove_id;
		removeTeamDraftLeague({ league_id: id,  team_id: team_id });
		this.setState({ remove_the_team: true });
	}

	fetchLadder() {
		const { fetchLadder, selected_league_id } = this.props;
		fetchLadder({
			league_id: selected_league_id,
		});
	}

	leaveThisLeague() {
		this.setState({ show_leave_modal: true });
	}

	removeFromLeague({ currentTarget }) {
		const { id } = currentTarget.dataset;
		this.setState({ show_remove_modal: true, remove_id: parseInt(id, 10) });
	}


	closeLeaveModal() {
		this.setState({ show_leave_modal: false });
	}

	closeRemoveModal() {
		this.setState({ show_remove_modal: false });
	}

	updateTextDraftOrder({ currentTarget }) {
		const { draft_order, league, changeDraftOrder } = this.props;
		const { id } = currentTarget.dataset;
		const to = currentTarget.value <= draft_order.length
			? currentTarget.value - 1 : draft_order.length - 1;
		const from = draft_order.indexOf(parseInt(id, 10));
		draft_order.splice(from, 1);
		draft_order.splice(to, 0, parseInt(id, 10));
		changeDraftOrder({
			team: draft_order,
			id: parseInt(league.id, 10),
		});
	}

	updateArrowsDraftOrder({ currentTarget }) {
		const { changeDraftOrder, league, draft_order } = this.props;

		const { from, to, id } = currentTarget.dataset;
		draft_order.splice(from, 1);
		draft_order.splice(to, 0, parseInt(id, 10));
		changeDraftOrder({
			team: draft_order,
			id: parseInt(league.id, 10),
		});
	}

	get leave_modal() {
		return (
			<ConfirmationModal
				header_text='League About'
				body_text='Are you sure you want to leave this league ?'
				confirmClick={this.confirmLeaveleague}
				cancelClick={this.closeLeaveModal}
				closeClick={this.closeLeaveModal}
			/>
		);
	}

	get remove_modal() {
		return (
			<ConfirmationModal
				header_text='League About'
				body_text='Are you sure you want to remove this user from league ?'
				confirmClick={this.confirmRemoveTeamleague}
				cancelClick={this.closeRemoveModal}
				closeClick={this.closeRemoveModal}
			/>
		);
	}

	get status_and_time_until_draft() {
		const
			{
				league,
			} = this.props;
		return (league.status === "scheduled"
			&& (Date.parse(league.draft_start) - Date.parse(Date())) > 1800000);
	}

	fetchLeague() {
		const { fetchLeague, selected_league_id } = this.props;
		fetchLeague({
			id: selected_league_id
		});
	}


	get draft_order_table_header() {
		return (
			<THead>
				<Tr>
					<DraftOrderTh
						width="100">
						<div className="highlighter" />
						<span className="column-name">Pos</span>
					</DraftOrderTh>
					<DraftOrderThHideSmall>
					</DraftOrderThHideSmall>
					<TeamTh
						width="100">
						<div className="highlighter" />
						<span className="column-name">Team</span>
					</TeamTh>
					<DraftOrderThHideSmall>
					</DraftOrderThHideSmall>
					<DraftOrderThHideLarge>
					</DraftOrderThHideLarge>
					<DraftOrderTh
						width="25%">
						<div className="highlighter" />
						<span className="column-name">Manage Team</span>
					</DraftOrderTh>
				</Tr>
			</THead>
		);
	}

	 removeOrLeaveButtons(team) {
		const {
			user_id,
			league
		} = this.props;
		if (user_id !== team.user_id
			&& user_id === league.commissioner && this.status_and_time_until_draft) {
			return (
				<TdStat>
					<ButtonAlert
						data-id={team.id}
						onClick={this.removeFromLeague}>
						REMOVE FROM LEAGUE
					</ButtonAlert>
				</TdStat>
			);
		}
		else if (user_id === team.user_id && this.status_and_time_until_draft) {
			return (
				<TdStat>
					<ButtonAlert
						onClick={this.leaveThisLeague}>
						LEAVE THIS LEAGUE
					</ButtonAlert>
				</TdStat>
			);
		}
		else {
			return (
				<TdStat>
				</TdStat>
			);
		}
	};

	get draft_order_table_body() {
		const {
			user_id,
			teams,
			league
		} = this.props;
		const cells = teams.map((team, index) => {
			const draft_order = index;
			const is_ignored = !(draft_order + 1);
			return (
				<DraftOrderRow
					className={is_ignored ? 'is-ignored' : null}
					key={team.id}
				>
					{ user_id === league.commissioner && (Date.parse(league.draft_start)
							- Date.parse(Date())) > 1800000 ? <TdDraftPosition alignText="right">
							<DraftOrder
								disabled={is_ignored}
								name="draft_order"
								onChange={this.updateTextDraftOrder}
								data-id={team.id}
								value={draft_order + 1}
							/>
							<ArrowDiv>
								<SwitchButton
									up={true}
									disabled={is_ignored || draft_order === 0}
									data-from={parseInt(draft_order, 10)}
									data-to={parseInt(draft_order, 10) - 1}
									data-id={team.id}
									onClick={this.updateArrowsDraftOrder}
								>
									<ArrowUp size='1.5' />
								</SwitchButton>
								<SwitchButton
									disabled={is_ignored || teams.length === draft_order + 1}
									data-from={parseInt(draft_order, 10)}
									data-to={parseInt(draft_order, 10) + 1}
									data-id={team.id}
									onClick={this.updateArrowsDraftOrder}
								>
									<ArrowDown size='1.5' />
								</SwitchButton>
							</ArrowDiv>
						</TdDraftPosition> : <TdDraftOrder>{draft_order + 1}</TdDraftOrder>}
					<TdStatHideSmall>
					</TdStatHideSmall>
					<TdStat width="40px">
						<OrderDiv>
							<TeamUserAvatarStyled
								user_id={team.user_id}
								avatar_version={team.avatar_version}
							/>
						</OrderDiv>
					</TdStat>
					<TdStat>
						<TeamName>{team.name}</TeamName>
						<UserName>{team.firstname} {team.lastname}</UserName>
					</TdStat>
					{this.removeOrLeaveButtons(team)}

				</DraftOrderRow>
			);
		});
		return <TBody>{ cells }</TBody>;
	}

	get league_table_header() {
		return (
			<THead>
				<Tr>
					<TeamTh
						width="100">
						<div className="highlighter" />
						<span className="column-name">Team</span>
					</TeamTh>
					<DraftOrderThHideSmall>
					</DraftOrderThHideSmall>
					<DraftOrderThHideSmall>
					</DraftOrderThHideSmall>
					<DraftOrderThHideLarge>
					</DraftOrderThHideLarge>
					<DraftOrderTh
						width="25%">
						<div className="highlighter" />
						<span className="column-name">Manage Team</span>
					</DraftOrderTh>
				</Tr>
			</THead>
		);
	}


	get league_table_body() {
		const {
			ladder_teams_ordered,
		} = this.props;

		const cells = ladder_teams_ordered.filter(o => o !== undefined).map((team, index) => {
			return (
				<DraftOrderRow
					key={team.id}
				>
					<TdStatHideSmall>
					</TdStatHideSmall>
					<TdStat width="40px">
						<OrderDiv>
							<TeamUserAvatarStyled
								user_id={team.user_id}
								avatar_version={team.avatar_version}
							/>
						</OrderDiv>
					</TdStat>
					<TdStat>
						<TeamName>{team.name}</TeamName>
						<UserName>{team.firstname} {team.lastname}</UserName>
					</TdStat>
					{this.removeOrLeaveButtons(team)}
				</DraftOrderRow>
			);
		});
		return <TBody>{ cells }</TBody>;
	}
	get show_draft_order_table() {
		const { league } = this.props;
		if (league.num_teams >= league.size) {
			return (
				<Table>
					{ this.draft_order_table_header }
					{ this.draft_order_table_body }
				</Table>
			);
		}
		else {
			return (
				<Table>
					{ this.league_table_header }
					{ this.league_table_body }
					{/* League is Not Full. There is Currently No Draft Order. */}
				</Table>
			);
		}
	}

	render() {
		const {
			league,
			leave_league_success,
			remove_team_success,
		} = this.props;

		const {
			show_leave_modal,
			show_remove_modal,
			left_the_league,
			remove_the_team
		} = this.state;

		return (
			<div>
				{remove_the_team && remove_team_success ?  <Redirect to='leagues' /> : null}
				{left_the_league && leave_league_success ? <Redirect to='leagues' /> : null}
				{show_leave_modal ? this.leave_modal : null}
				{show_remove_modal ? this.remove_modal : null}
				<DraftLayout >

					<DraftDiv>
						<DraftTitleContainer>
							<PageTitle>Draft Order for {league.name}</PageTitle>
						</DraftTitleContainer>
						{this.show_draft_order_table}
					</DraftDiv>
					<Aside>
					</Aside>
				</DraftLayout>
			</div>
		);
	}
}
const mapStateToProps = (state, props) => {
	const { leagues: { show_order: { error }, teams_by_id } } = state;
	const selected_league_id = props.match.params.league_id;
	const teams = selectors.leagueDraft.getLeagueDraftOrder(state).map(
		team_id => teams_by_id[team_id]
	).filter(_.identity);
	return {
		selected_league_id,
		league: selectors.leagueDraft.getLeague(state, props),
		is_pending_show: selectors.leagueDraft.show.isPending(state),
		user_id: selectors.getUser(state).id,
		leave_league_success: state.leagues.leave.success,
		remove_team_success: state.leagues.remove_team.success,
		draft_order: state.leagues.show_order.ordered_ids,
		ladder_teams_ordered: selectors.leagueDraft.ladder.getOrdered(state),
		error,
		teams_by_id,
		teams
	};
};

const mapDispatchToProps = {
	fetchLeague: actions.leagueDraft.showDraftLeague,
	fetchLadder: actions.leagueDraft.ladderDraftLeague,
	leaveDraftLeague: actions.leagueDraft.leaveDraftLeague,
	removeTeamDraftLeague: actions.leagueDraft.removeTeamDraftLeague,
	showDraftOrder: actions.leagueDraft.showDraftOrder,
	changeDraftOrder: actions.leagueDraft.changeDraftOrder,
};

export const LeagueDraftOrder = connect(
	mapStateToProps,
	mapDispatchToProps,
)(LeagueDraftOrderComponent);

export default LeagueDraftOrder;


// WEBPACK FOOTER //
// ./src/pages/league/LeagueDraftOrder.js